import React from 'react';
import { appContext } from '../../util/decorators';

@appContext
export default class TwitterFollowWidget extends React.PureComponent {
  static propTypes = {
    title: React.PropTypes.string.isRequired,
    url: React.PropTypes.string.isRequired,
    logo: React.PropTypes.string.isRequired,
  };

  render() {
    const logo = require(`../../../assets/logos/${this.props.logo}`);

    return (
      <div className="twitter-follow-widget">
        <img src={logo} alt={`${this.props.title} logo`} className="logo" />
        <h3>{this.props.title}</h3>
        <a
          href={this.props.url}
          className="twitter-follow-button structural"
          data-show-count="false"
          data-size="large"
          data-show-screen-name="false">
          {this.context.app.t('TwitterFollowWidget.follow')} {this.props.title} @twitter</a>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/Page/TwitterFollowWidget.jsx